import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom/client';
import React from 'react';
import App from './App';
import { syncAnalyticsConsentState } from './services/analytics';
import './assets/index.css';
import './assets/Forms.css';
import './assets/Modal.css';
import './assets/DataTable.css';
import './assets/Page.css';

syncAnalyticsConsentState();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
